import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AppShell from "../../components/layout/AppShell";
import TaskBoard from "../../components/tasks/TaskBoard";
import { api, formatApiError } from "../../lib/api";
import { saveBlob } from "../finance/invoice-analytics/iaUtils";

export default function CrmTasks() {
  const [prefill, setPrefill] = useState(null);
  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const ticket = sp.get("ticket"), message = sp.get("message");
    if (!ticket && !message) return;
    api.get("/crm-tasks/prefill", { params: ticket ? { ticket_id: ticket } : { message_id: message } })
      .then(r => setPrefill(r.data)).catch(e => toast.error(formatApiError(e)));
    window.history.replaceState({}, "", "/crm/tasks");
  }, []);
  return (
    <AppShell title="Tasks" subtitle="CRM · team tasks & assigned tickets">
      <div className="max-w-7xl">
        <TaskBoard client={api} ticketLink="/crm/tickets?tab=assigned" onSave={saveBlob}
          prefill={prefill} clearPrefill={() => setPrefill(null)} customerHref={id => `/customers/${id}`} />
      </div>
    </AppShell>
  );
}
